import { ofType } from "redux-observable";
import { empty, of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { push } from "react-router-redux";
import { notification } from "antd";
import { pendingAccount, begin, end } from "react-redux-spinner";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";
import activeStorageUpload from "../services/uploadService";

import AccountService from "../services/accountService";

import {
  loadAccountsSuccess,
  loadAccountsFailure,
  LOAD_ACCOUNTS_REQUEST_ACTION,
  SAVE_ACCOUNT_REQUEST_ACTION,
  saveAccountFailure,
  saveAccountSuccess,
  DELETE_ACCOUNT_REQUEST_ACTION,
  deleteAccountFailure,
  deleteAccountSuccess,
  LOAD_ACCOUNT_REQUEST_ACTION,
  loadAccountSuccess,
  loadAccountFailure,
  LOAD_ACTIVE_ACCOUNT_REQUEST_ACTION,
  SAVE_ACCOUNT_SUCCESS_ACTION,
  SAVE_ACCOUNT_FAILURE_ACTION,
  saveAccountRequest,
  LOAD_ACCOUNT_FAILURE_ACTION
} from "../ducks/data";
import {
  saveAccountFormSuccess,
  saveAccountFormFailure,
  SAVE_ACCOUNT_FORM_REQUEST_ACTION
} from "../ducks/account";
import { setActiveDialog, logout } from "../ducks/app";

const _ = require("lodash");
export const loadAccountEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ACCOUNT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      window.localStorage.setItem("app.Account", action.payload);

      let accountService = new AccountService();
      return accountService
        .find(action.payload)
        .then(response => {
          return loadAccountSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadAccountFailure(parseError(error));
        });
    })
  );

export const loadAccountFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ACCOUNT_FAILURE_ACTION.getType()),
    mergeMap(action => {
      return concat(of(logout()));
    })
  );
export const loadActiveAccountEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ACTIVE_ACCOUNT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let accountService = new AccountService();
      return accountService
        .activeAccount(action.payload)
        .then(response => {
          return loadAccountSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadAccountFailure(parseError(error));
        });
    })
  );

export const loadAccountsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ACCOUNTS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let accountService = new AccountService();
      return accountService
        .findAll(action.payload)
        .then(response => {
          return loadAccountsSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadAccountsFailure(parseError(error));
        });
    })
  );

export const saveAccountFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_ACCOUNT_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      if (action.payload.attachments) {
        let uploads = action.payload.attachments.map(file =>
          activeStorageUpload(file)
        );

        return Promise.all(uploads)
          .then(blobs => {
            let account = action.payload;
            account.attachments = blobs;
            // TODO: create attachments with blob signed ids and return them
            return saveAccountRequest(account);
          })
          .catch(error => {
            return saveAccountFailure(parseError(error));
          });
      } else {
        return of(saveAccountRequest(action.payload));
      }
    })
  );

export const saveAccountFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_ACCOUNT_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return concat(
        of(saveAccountFormSuccess(action.payload.user)),
        of(setActiveDialog())
      );
    })
  );

export const saveAccountFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_ACCOUNT_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveAccountFormFailure(action.payload));
    })
  );

export const saveAccountEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_ACCOUNT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let account = action.payload;

      let secureKeys = _.first(
        action.payload.attachments &&
          action.payload.attachments.map(a => a.signed_id)
      );
      account.attributes.secureKeys = secureKeys;
      let service = new AccountService();
      return service
        .save(account)
        .then(response => {
          return saveAccountSuccess(normalize(response.data));
        })
        .catch(error => {
          return saveAccountFailure(parseError(error));
        });
    })
  );

export const deleteAccountEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_ACCOUNT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new AccountService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteAccountSuccess(action.payload);
          })
          .catch(error => {
            return deleteAccountFailure(error);
          }),
        of(setActiveDialog())
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/accounts.js